import { FC, useEffect, useState } from "react"
import s from "./award.module.scss"
import { Link } from "react-router-dom";

interface IAwardLine {
    icon: any;
    caption: string;
    type: 'text' | 'link' | 'type' | 'agegender' | 'location';
    data?: string;
    gender?: string;
    age?: number;
    country?: string;
    city?: string;
}

export const AwardLine: FC<IAwardLine> = ({ icon, caption, type, data, gender, age, country, city }): JSX.Element => {
    const [desc, setDesc] = useState('')
    const [typeColor, setTypeColor] = useState('rgba(221, 190, 144, 0.30)')

    useEffect(() => {
        if (type === 'text' && !!data && !age && !gender && !country && !city) {
            setDesc(data)
        }
        if (type === 'location' && !!country && !!city && !data && !age && !gender) {
            setDesc(country + '; ' + city)
        }
        if (type === 'location' && !!country && !city && !data && !age && !gender) {
            setDesc(country)
        }
        if (type === 'link' && !!data && !age && !gender && !country && !city) {
            setDesc(data)
        }
        if (type === 'agegender' && !!gender && !!age && !data && !country && !city) {
            const _gender = gender === 'male' ? 'Мужчина' : 'Женщина'
            const lastDigit = age % 10;
            let _years
            if (lastDigit === 1) {
                _years = 'год'
            }
            if (lastDigit > 1 && lastDigit < 5) {
                _years = 'года'
            }
            if (lastDigit > 5 || lastDigit === 0) {
                _years = 'лет'
            }
            setDesc(`${age} ${_years}; ${_gender}`)
        }
        if (type === 'type' && !!data && !age && !gender && !country && !city) {
            if (data === 'high') {
                setTypeColor('rgba(255, 0, 0, 0.10)')
                setDesc('Высокая')
            }
            if (data === 'medium') {
                setTypeColor('rgba(255, 255, 0, 0.10)')
                setDesc('Средняя')
            }
            if (data === 'low') {
                setTypeColor('rgba(0, 0, 255, 0.10)')
                setDesc('Низкая')
            }
            if (data === 'sport') {
                setDesc('Спортивная награда')
            }
            if (data === 'non_sport') {
                setDesc('Неспортивная награда')
            }
        }
    }, [data, age, gender, country, city])
    return (
        <div className={s.awardLine}>
            <div className={s.awardLineIcon}>
                {icon}
            </div>
            <div className={s.awardLineData}>
                <div className={s.awardLineDataCaption}>
                    {caption}
                </div>
                {type === 'agegender' && <div className={s.awardLineDataText}>
                    {desc}
                </div>}
                {type === 'text' && <div className={s.awardLineDataText}>
                    {desc}
                </div>}
                {type === 'location' && <div className={s.awardLineDataText}>
                    {desc}
                </div>}
                {type === 'link' && <div className={s.awardLineDataLink}>
                    <span>{desc}</span> <Link to={desc} target="_blank"><svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.7962 19.8614C15.9211 19.9863 15.9912 20.1558 15.9912 20.3325C15.9912 20.5092 15.9211 20.6786 15.7962 20.8036L14.9681 21.6367C14.0923 22.5119 12.9048 23.0033 11.6667 23.0029C10.4286 23.0025 9.24143 22.5103 8.36624 21.6346C7.49106 20.7589 6.99961 19.5713 7 18.3332C7.00039 17.0952 7.49259 15.9079 8.36833 15.0328L10.3777 13.0233C11.2189 12.1815 12.35 11.6929 13.5395 11.6576C14.729 11.6223 15.8871 12.0429 16.7767 12.8334C16.8424 12.8916 16.8959 12.9622 16.9343 13.041C16.9726 13.1199 16.9951 13.2056 17.0004 13.2932C17.0056 13.3808 16.9936 13.4685 16.9649 13.5514C16.9363 13.6343 16.8916 13.7108 16.8334 13.7764C16.7752 13.8421 16.7046 13.8956 16.6257 13.934C16.5468 13.9724 16.4611 13.9948 16.3736 14.0001C16.286 14.0053 16.1983 13.9933 16.1153 13.9647C16.0324 13.936 15.956 13.8913 15.8903 13.8331C15.2549 13.2689 14.428 12.9687 13.5786 12.9939C12.7292 13.0191 11.9216 13.3679 11.3208 13.9689L9.31139 15.9758C8.68632 16.6009 8.33516 17.4487 8.33516 18.3326C8.33516 19.2166 8.68632 20.0644 9.31139 20.6894C9.93645 21.3145 10.7842 21.6657 11.6682 21.6657C12.5522 21.6657 13.4 21.3145 14.025 20.6894L14.8531 19.8614C14.915 19.7994 14.9885 19.7502 15.0694 19.7167C15.1503 19.6831 15.2371 19.6659 15.3246 19.6659C15.4122 19.6659 15.499 19.6831 15.5799 19.7167C15.6608 19.7502 15.7343 19.7994 15.7962 19.8614ZM21.6345 8.36468C20.7586 7.49079 19.5719 7 18.3346 7C17.0973 7 15.9106 7.49079 15.0347 8.36468L14.2066 9.19361C14.0817 9.31867 14.0115 9.48824 14.0116 9.66502C14.0117 9.8418 14.082 10.0113 14.2071 10.1363C14.3321 10.2612 14.5017 10.3314 14.6785 10.3313C14.8552 10.3312 15.0247 10.2609 15.1497 10.1358L15.9778 9.30774C16.6029 8.68268 17.4506 8.33152 18.3346 8.33152C19.2186 8.33152 20.0664 8.68268 20.6914 9.30774C21.3165 9.93281 21.6676 10.7806 21.6676 11.6646C21.6676 12.5485 21.3165 13.3963 20.6914 14.0214L18.682 16.0325C18.0809 16.6331 17.2731 16.9814 16.4237 17.0062C15.5743 17.031 14.7476 16.7303 14.1125 16.1658C13.9799 16.0482 13.8061 15.9881 13.6292 15.9988C13.4524 16.0094 13.287 16.0898 13.1694 16.2224C13.0519 16.355 12.9918 16.5288 13.0024 16.7057C13.0131 16.8825 13.0935 17.0479 13.2261 17.1655C14.1155 17.9561 15.2734 18.377 16.463 18.342C17.6525 18.307 18.7837 17.8188 19.6251 16.9772L21.6345 14.9678C22.5089 14.0918 23 12.9047 23 11.6671C23 10.4294 22.5089 9.24228 21.6345 8.36635V8.36468Z" fill="#CDCDCD" />
                    </svg>
                    </Link>
                </div>}
                {type === 'type' && <div className={s.awardLineDataType}>
                    <span style={{ background: typeColor }}>{desc}</span>
                </div>}
            </div>
        </div>
    )
}